enum ThemeColor {
  AQUA = 'aqua',
  BLUE = 'blue',
  GREEN = 'green',
  GREY = 'grey',
  GROUP_BLUE = 'group-blue',
  ORANGE = 'orange',
  PINK = 'pink',
  PURPLE = 'purple',
}

export default ThemeColor;
